import React from 'react'
import { Link } from 'gatsby'
import { Box, Image, ImageProps, useColorModeValue } from '@chakra-ui/react'

import LightLogo from '~images/logos/fp-text-logo-white.svg'
import DarkLogo from '~images/logos/fp-text-logo-black.svg'

const Logo: React.FC<ImageProps> = props => {
  const logo = useColorModeValue(DarkLogo, LightLogo)

  return (
    <Box>
      <Link to="/">
        <Image src={logo} w="80px" {...props} alt="Festival Pass Logo" />
      </Link>
    </Box>
  )
}

export default Logo
